import Checbox from './checkbox.component'

export default Checbox
